import * as React from 'react';
import discardAppearanceOption from './data/mutators/discardAppearanceOption';
import saveAppearanceOption from './orchestration/saveAppearanceOption';
import AppearanceFull from './view/AppearanceFull';
import AppearanceQuick from './view/AppearanceQuick';
import isAppearanceOptionDirty from './utils/isAppearanceOptionDirty';
var AppearanceOption = {
    key: 'appearance',
    titleStringKey: 'optionTitle_appearance',
    searchTermsStringKey: 'optionSearch_appearance',
    fullOptionFormSettings: {
        render: function () { return React.createElement(AppearanceFull, null); },
        isDirty: isAppearanceOptionDirty,
        onSave: saveAppearanceOption,
        onDiscard: discardAppearanceOption,
    },
    quickOptionSettings: {
        rendering: {
            render: function () { return React.createElement(AppearanceQuick, null); },
        },
        order: 11 /* CalendarAppearance */,
        workloads: 2 /* Calendar */,
    },
};
export default AppearanceOption;
//# sourceMappingURL=AppearanceOption.js.map